export const Config = {
    googleAnalyticsId: "UA-184194034-1",
    tagmanagerId: "GTM-P4WF674",
    googleApiKey: "AIzaSyA3VbKwtad-aQp3cIkrDfukT6zm9ygIASw",
    // backendUrl: 'https://backend.kzsdev.hu',
};
